import { noop } from 'helpers/event';
import styled from 'styled-components';
import device from 'ui/theme/device';
import { spacing } from 'ui/theme/utils';

const getColorFromStatus = (status) => {
  switch (status) {
    case 'success':
      return '#00AA22';
    case 'failed':
      return '#FF0000';
    case 'warning':
      return '#F5D946';
    case 'late':
      return '#8900FF';
    default:
      return '#AAA';
  }
};

export const Dot = styled.a.attrs(
  ({ color, status, isForceGreen, size = 16, mobileSize = 12, onClick = noop, dataCy }) => ({
    color: color || getColorFromStatus(status),
    isForceGreen,
    size,
    mobileSize: mobileSize || size - parseInt(size / 4),
    onClick,
    'data-cy': dataCy || `job-dot-${status}`,
  })
)`
  position: relative;
  display: inline-block;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  padding: ${({ size }) => `${parseInt(size / 2)}px`}; // affects EditJob component
  border-radius: 50%;
  background-color: ${({ color = '#aaa' }) => color};
  cursor: ${({ cursor = 'pointer' }) => cursor};
  ${(props) => spacing(props)}
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
  `}
  ${({ status, isForceGreen }) =>
    status === 'success' &&
    isForceGreen &&
    `
      position: relative;
      border-radius: 4px;
  `}
  @media ${device.small} {
    width: ${({ mobileSize }) => `${mobileSize}px`};
    height: ${({ mobileSize }) => `${mobileSize}px`};
    padding: ${({ mobileSize }) => `${parseInt(mobileSize / 2)}px`};
  }
  &:after {
    content: '';
    padding: 3px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 300ms ease-in-out;
  }
`;
